<template>
	<div class="legalwrapper">
		<div class="container-fluid">
			<h1>PRIVACY</h1>
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<div>
						<h3>Website privacy policy</h3>
						<p>Outlines privacy and data protection practices on our websites.</p>
						<nuxt-link to="/privacy-web" tag="a">Read our Privacy Policy for Websites</nuxt-link>
					</div>
					<div>
						<h3>EEA Privacy Policy</h3>
						<p>Outlines privacy and data protection practices in our apps for the European Economic Area.</p>
						<nuxt-link to="/eea/en" tag="a">Read our Privacy Policy for EEA</nuxt-link>
					</div>
				</div>
				<div class="col-sm-12 col-md-7">
					<div>
						<h3>US Apps Privacy Policy</h3>
						<p>Outlines privacy and data protection practices in our apps for the US.</p>
						<nuxt-link to="/privacy/en" tag="a">Read our Privacy Policy for Apps</nuxt-link>
					</div>
					<div>
						<h3>Apps Privacy Policy rest of the world</h3>
						<p>Outlines privacy and data protection practices in our apps for the rest of the world.</p>
						<nuxt-link to="/privacy/en" tag="a">Read our Privacy Policy for Apps</nuxt-link>
					</div>
					<div>
						<h3>California Apps Privacy Policy</h3>
						<p>Outlines privacy and data protection practices in our apps for California.</p>
						<nuxt-link to="/privacy/ccpa/" tag="a">Read our Privacy Policy for Apps </nuxt-link>
					</div>
					<div>
						<h3>Brazil Apps Privacy Policy</h3>
						<p>Outlines privacy and data protection practices in our apps for Brazil.</p>
						<nuxt-link to="/privacy-brazil/en/" tag="a">Read our Privacy Policy for Apps</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.legalwrapper {
	min-height: 100vh;
}
</style>
